function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

var ONE_REM = parseInt(document.documentElement.style.fontSize, 10) || 100;
var SCALE = ONE_REM / 100;
/**
 * 像素转换
 * @param {Number} px - 750视觉稿像素
 * @return {Number} 屏幕上实际像素
 */

function px2hd(px) {
  return Number((px * SCALE).toFixed(1));
}

var GesturePassword = /*#__PURE__*/function () {
  function GesturePassword(props) {
    _classCallCheck(this, GesturePassword);

    this.initCircleCoordinate = []; // 圆的初始化坐标

    this.selectedCoordinate = []; // 圆的初始化坐标

    this.candidateCoordinate = []; // 圆的初始化坐标

    var id = props.id,
        width = props.width,
        height = props.height,
        _props$background = props.background,
        background = _props$background === void 0 ? '#FFF' : _props$background,
        _props$lineColor = props.lineColor,
        lineColor = _props$lineColor === void 0 ? '#0089FF' : _props$lineColor,
        _props$lineBackground = props.lineBackground,
        lineBackground = _props$lineBackground === void 0 ? '#D9EDFF' : _props$lineBackground,
        _props$rowPont = props.rowPont,
        rowPont = _props$rowPont === void 0 ? 3 : _props$rowPont,
        _props$colPont = props.colPont,
        colPont = _props$colPont === void 0 ? 3 : _props$colPont,
        _props$onChange = props.onChange,
        onChange = _props$onChange === void 0 ? function () {} : _props$onChange,
        onCustomizeDraw = props.onCustomizeDraw;
    var el = props.el || id && window.document.getElementById(id);

    if (!(el instanceof HTMLCanvasElement)) {
      throw new Error('[GesturePassword] element should be an instance of HTMLCanvasElement');
    }

    this.el = el;
    this.context = this.el.getContext('2d');
    this.width = width;
    this.height = height;
    this.background = background;
    this.lineColor = lineColor;
    this.lineBackground = lineBackground;
    this.onChange = onChange;
    this.onCustomizeDraw = onCustomizeDraw;
    this.circleR = this.width * 28 / 375;

    if (this.width > this.height) {
      this.circleR = this.height * 28 / 375;
    }

    this.rowPont = rowPont;
    this.colPont = colPont;
    this.isActive = false;
    this.initCanvas();
    this.addEventListener();
  }

  _createClass(GesturePassword, [{
    key: "updateProps",
    value: function updateProps(props) {
      var width = props.width,
          height = props.height,
          _props$background2 = props.background,
          background = _props$background2 === void 0 ? '#FFF' : _props$background2,
          _props$lineColor2 = props.lineColor,
          lineColor = _props$lineColor2 === void 0 ? '#0089FF' : _props$lineColor2,
          _props$lineBackground2 = props.lineBackground,
          lineBackground = _props$lineBackground2 === void 0 ? '#D9EDFF' : _props$lineBackground2,
          _props$rowPont2 = props.rowPont,
          rowPont = _props$rowPont2 === void 0 ? 3 : _props$rowPont2,
          _props$colPont2 = props.colPont,
          colPont = _props$colPont2 === void 0 ? 3 : _props$colPont2,
          _props$onChange2 = props.onChange,
          onChange = _props$onChange2 === void 0 ? function () {} : _props$onChange2,
          onCustomizeDraw = props.onCustomizeDraw;
      this.width = width;
      this.height = height;
      this.background = background;
      this.lineColor = lineColor;
      this.lineBackground = lineBackground;
      this.onChange = onChange;
      this.onCustomizeDraw = onCustomizeDraw;
      this.circleR = this.width * 28 / 375;

      if (this.width > this.height) {
        this.circleR = this.height * 28 / 375;
      }

      this.rowPont = rowPont;
      this.colPont = colPont;
      this.initCanvas();
    }
  }, {
    key: "initCanvas",
    value: function initCanvas() {
      this.initCircleCoordinate = this.getCircleCoordinate();
      this.candidateCoordinate = this.initCircleCoordinate;
      this.selectedCoordinate = [];
      this.draw();
    }
  }, {
    key: "addEventListener",
    value: function addEventListener() {
      var self = this;

      var touchstartFun = function touchstartFun(e) {
        e.preventDefault();
        var po = self.getPosition(e);
        if (!po) return;

        for (var i = 0; i < self.candidateCoordinate.length; i++) {
          if (self.collisionDetection(po, self.candidateCoordinate[i])) {
            self.isActive = true;
            self.selectedCoordinate.push(self.candidateCoordinate[i]);
            self.candidateCoordinate.splice(i, 1);
            self.draw(); // 碰撞检测通过需要重绘canvans

            break;
          }
        }
      };

      var touchmoveFun = function touchmoveFun(e) {
        if (self.isActive) {
          var po = self.getPosition(e);
          if (!po) return;
          self.updateCanvas(po);
        }
      };

      var touchendFun = function touchendFun(_e) {
        if (self.isActive) {
          self.isActive = false;
          self.draw(); // 这里应该把数据传出去
          // 重制绘图

          self.onChange(self.getPassword());
          self.initCanvas();
        }
      }; // <!-- <script src="https://gw.alipayobjects.com/os/rmsportal/NjNldKHIVQRozfbAOJUW.js"></script> -->
      // 设备兼容


      if ('ontouchstart' in document.documentElement) {
        this.el.addEventListener('touchstart', touchstartFun, false);
        this.el.addEventListener('touchmove', touchmoveFun, false);
        this.el.addEventListener('touchend', touchendFun, false);
      } else {
        this.el.addEventListener('mousedown', touchstartFun, false);
        this.el.addEventListener('mousemove', touchmoveFun, false);
        this.el.addEventListener('mouseup', touchendFun, false);
      }
    }
  }, {
    key: "getPassword",
    value: function getPassword() {
      return this.selectedCoordinate.map(function (i) {
        return i.key;
      });
    }
    /**
     *
     * @param po 更新画布
     */

  }, {
    key: "updateCanvas",
    value: function updateCanvas(po) {
      this.draw();
      var last = this.selectedCoordinate[this.selectedCoordinate.length - 1];
      this.context.beginPath();
      this.context.moveTo(po.x, po.y);
      this.context.lineTo(last.x, last.y);
      this.context.closePath();
      this.context.stroke(); // 滑动经过圆点

      for (var i = 0; i < this.candidateCoordinate.length; i++) {
        if (this.collisionDetection(po, this.candidateCoordinate[i])) {
          this.isActive = true;
          this.selectedCoordinate.push(this.candidateCoordinate[i]);
          this.candidateCoordinate.splice(i, 1);
          break;
        }
      }
    }
    /**
     * 碰撞检测
     */

  }, {
    key: "collisionDetection",
    value: function collisionDetection(a, b) {
      var rX = Math.abs(a.x - b.x);
      var rY = Math.abs(a.y - b.y);

      if (rX * rX + rY * rY < this.circleR * this.circleR) {
        return true;
      }

      return false;
    }
    /**
     * 获取点的坐标
     */

  }, {
    key: "getCircleCoordinate",
    value: function getCircleCoordinate() {
      var offsetx = (this.width - this.rowPont * this.circleR * 2) / (this.rowPont + 1);
      var offsety = (this.height - this.rowPont * this.circleR * 2) / (this.colPont + 1);
      var circleCoordinate = [];

      for (var col = 0; col < this.colPont; col++) {
        for (var row = 0; row < this.rowPont; row++) {
          circleCoordinate.push({
            x: offsetx * (row + 1) + this.circleR * (2 * row + 1),
            y: offsety * (col + 1) + this.circleR * (2 * col + 1),
            key: 3 * col + row + 1
          });
        }
      }

      return circleCoordinate;
    }
    /**
      * 默认绘制函数
      */

  }, {
    key: "onDefaultDraw",
    value: function onDefaultDraw() {
      // 清空绘图
      this.context.clearRect(0, 0, this.width, this.height); // 绘制背景

      this.context.fillStyle = this.background;
      this.context.fillRect(0, 0, this.width, this.height); // 绘制默认圆点

      this.context.lineWidth = 1;
      this.context.strokeStyle = this.lineColor;
      this.context.beginPath();

      for (var i = 0, r = this.circleR; i < this.initCircleCoordinate.length; i++) {
        this.context.moveTo(this.initCircleCoordinate[i].x + r, this.initCircleCoordinate[i].y);
        this.context.arc(this.initCircleCoordinate[i].x, this.initCircleCoordinate[i].y, r, 0, Math.PI * 2, true);
      }

      this.context.stroke();
      this.context.closePath(); // 绘制连线

      this.context.strokeStyle = this.lineColor;
      this.context.beginPath();

      for (var _i = 0; _i < this.selectedCoordinate.length; _i++) {
        this.context.lineTo(this.selectedCoordinate[_i].x, this.selectedCoordinate[_i].y);
      }

      this.context.stroke();
      this.context.closePath(); // 绘制被选中的点的背景 #D9EDFF

      this.context.fillStyle = this.lineBackground;
      this.context.beginPath();

      for (var _i2 = 0; _i2 < this.selectedCoordinate.length; _i2++) {
        this.context.moveTo(this.selectedCoordinate[_i2].x + this.circleR / 2, this.selectedCoordinate[_i2].y);
        this.context.arc(this.selectedCoordinate[_i2].x, this.selectedCoordinate[_i2].y, this.circleR, 0, Math.PI * 2, true);
      }

      this.context.fill();
      this.context.closePath(); // 绘制被选中的点的中心圆 大小是圆面积的 20/56

      this.context.fillStyle = this.lineColor;
      this.context.beginPath();

      for (var _i3 = 0; _i3 < this.selectedCoordinate.length; _i3++) {
        this.context.moveTo(this.selectedCoordinate[_i3].x + this.circleR / 2, this.selectedCoordinate[_i3].y);
        this.context.arc(this.selectedCoordinate[_i3].x, this.selectedCoordinate[_i3].y, this.circleR * 20 / 56, 0, Math.PI * 2, true);
      }

      this.context.fill();
      this.context.closePath();
    }
    /**
     * 绘制函数
     */

  }, {
    key: "draw",
    value: function draw() {
      if (this.onCustomizeDraw) {
        this.onCustomizeDraw({
          context: this.context,
          width: this.width,
          height: this.height,
          background: this.background,
          lineColor: this.lineColor,
          lineBackground: this.lineBackground,
          initCircleCoordinate: this.initCircleCoordinate,
          circleR: this.circleR,
          selectedCoordinate: this.selectedCoordinate
        });
      } else {
        this.onDefaultDraw();
      }
    }
    /**
     * 获取点击的位置坐标
     * @param e
     */

  }, {
    key: "getPosition",
    value: function getPosition(e) {
      if (!(e.currentTarget instanceof Element)) return;
      var rect = e.currentTarget.getBoundingClientRect();
      var clientX = 'touches' in e ? e.touches[0].clientX : e.clientX;
      var clientY = 'touches' in e ? e.touches[0].clientY : e.clientY;
      return {
        x: clientX - rect.left,
        y: clientY - rect.top
      };
    }
  }]);

  return GesturePassword;
}();

//
var script = {
  name: 'GesturePassword',
  props: {
    width: {
      type: Number,
      required: true
    },
    height: {
      type: Number,
      required: true
    },
    background: String,
    lineColor: String,
    lineBackground: String,
    rowPont: Number,
    colPont: Number
  },
  data: function data() {
    return {
      canvas: null,
      el: null
    };
  },
  computed: {
    px2hdHeight: function px2hdHeight() {
      return px2hd(this.height);
    },
    px2hdWidth: function px2hdWidth() {
      return px2hd(this.width);
    }
  },
  mounted: function mounted() {
    this.portalRef();
    this.createCanvasInstance(this.$props);
  },
  updated: function updated() {
    this.createCanvasInstance(this.$props);
  },
  beforeDestroy: function beforeDestroy() {
    if (this.canvas) {
      // 组件销毁
      this.canvas = null;
    }

    this.el = null;
  },
  methods: {
    createCanvasInstance: function createCanvasInstance(props) {
      if (!this.canvas) {
        var mergeProps = Object.assign({}, props, {
          width: px2hd(props.width),
          height: px2hd(props.height),
          onChange: this.$listeners ? this.$listeners.onChange : this.$attrs.onOnChange,
          onCustomizeDraw: this.$listeners ? this.$listeners.onCustomizeDraw : this.$attrs.onOnCustomizeDraw
        });
        this.canvas = new GesturePassword(Object.assign({}, mergeProps, {
          el: this.el
        }));
      }
    },
    portalRef: function portalRef() {
      if (!this.el) {
        this.el = this.$refs.canvasRef;
      }
    }
  }
};

function normalizeComponent(template, style, script, scopeId, isFunctionalTemplate, moduleIdentifier
/* server only */
, shadowMode, createInjector, createInjectorSSR, createInjectorShadow) {
  if (typeof shadowMode !== 'boolean') {
    createInjectorSSR = createInjector;
    createInjector = shadowMode;
    shadowMode = false;
  } // Vue.extend constructor export interop.


  var options = typeof script === 'function' ? script.options : script; // render functions

  if (template && template.render) {
    options.render = template.render;
    options.staticRenderFns = template.staticRenderFns;
    options._compiled = true; // functional template

    if (isFunctionalTemplate) {
      options.functional = true;
    }
  } // scopedId


  if (scopeId) {
    options._scopeId = scopeId;
  }

  var hook;

  if (moduleIdentifier) {
    // server build
    hook = function hook(context) {
      // 2.3 injection
      context = context || // cached call
      this.$vnode && this.$vnode.ssrContext || // stateful
      this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext; // functional
      // 2.2 with runInNewContext: true

      if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
        context = __VUE_SSR_CONTEXT__;
      } // inject component styles


      if (style) {
        style.call(this, createInjectorSSR(context));
      } // register component module identifier for async chunk inference


      if (context && context._registeredComponents) {
        context._registeredComponents.add(moduleIdentifier);
      }
    }; // used by ssr in case component is cached and beforeCreate
    // never gets called


    options._ssrRegister = hook;
  } else if (style) {
    hook = shadowMode ? function (context) {
      style.call(this, createInjectorShadow(context, this.$root.$options.shadowRoot));
    } : function (context) {
      style.call(this, createInjector(context));
    };
  }

  if (hook) {
    if (options.functional) {
      // register for functional component in vue file
      var originalRender = options.render;

      options.render = function renderWithStyleInjection(h, context) {
        hook.call(context);
        return originalRender(h, context);
      };
    } else {
      // inject component registration as beforeCreate hook
      var existing = options.beforeCreate;
      options.beforeCreate = existing ? [].concat(existing, hook) : [hook];
    }
  }

  return script;
}

/* script */
var __vue_script__ = script;
/* template */

var __vue_render__ = function __vue_render__() {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('canvas', {
    ref: "canvasRef",
    attrs: {
      "width": _vm.px2hdWidth,
      "height": _vm.px2hdWidth
    }
  });
};

var __vue_staticRenderFns__ = [];
/* style */

var __vue_inject_styles__ = undefined;
/* scoped */

var __vue_scope_id__ = undefined;
/* module identifier */

var __vue_module_identifier__ = undefined;
/* functional template */

var __vue_is_functional_template__ = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

var __vue_component__ = /*#__PURE__*/normalizeComponent({
  render: __vue_render__,
  staticRenderFns: __vue_staticRenderFns__
}, __vue_inject_styles__, __vue_script__, __vue_scope_id__, __vue_is_functional_template__, __vue_module_identifier__, false, undefined, undefined, undefined);

__vue_component__.install = function (app) {
  return app.component(__vue_component__.name, __vue_component__);
};

export default __vue_component__;
